import theme from '../../styles/theme';
import { QUOTE_MARK, COLUMN_SEPARATOR, SPACE_KEY } from '../../utils/Constants';

/*Método para formatear la row para agregarlo al grid-area-template
  Entrada: 'area-1 otraArea-2'     Salida: 'area otraArea otraArea'
 * 1 - Splitea por cada espacio dentro de la row para obtener las areas(Ej: [area-1, otraArea-2])
 * 2 - Splitea de nuevo para separar areas de cantidad de columnas. (Ej: [['area', 1], ['otraArea',2]])
 * 3 - Recorro cada array del array general donde repito el string del area la cantidad de columnas especificada (Ej.: otraArea otraArea)
 *  3.1 - Si es que no tengo una cantidad especifica ocupo el máximo de columnas (Ej: Si ['area'] => columnIncrease = 8)
 *  3.2 - Siempre valido que la cantidad de columnas a sumar al string no sean mayores
 *        que la cantidad maxima permitida => columnCount < maxColumns
 */
const formatGridArea = (value, breakpoint) => {
  let columnCount = 0;
  const maxColumns = theme.breakpoints[breakpoint].columns;
  return value
    .split(SPACE_KEY)
    .map((areaColumn) => areaColumn.split(COLUMN_SEPARATOR))
    .reduce((row, item) => {
      let area = item[0];
      let columnIncrease = item[1] || maxColumns;
      columnCount += parseInt(columnIncrease);
      return row.concat(
        area
          .concat(SPACE_KEY)
          .repeat(validateColumnLength(columnCount, columnIncrease, maxColumns))
      );
    }, '')
    .trim();
};

const validateColumnLength = (actualCount, increase, maxNumber) =>
  actualCount <= maxNumber ? increase : increase - (actualCount - maxNumber);

const buildRow = (value, breakpoint) =>
  QUOTE_MARK.concat(formatGridArea(value, breakpoint), QUOTE_MARK);

const buildGridArea = (values, breakpoint) =>
  values.reduce((acc, item) => acc.concat(buildRow(item, breakpoint)), '');

export { buildGridArea };
